import {
	Box,
	Divider,
	FormControlLabel,
	FormHelperText,
	Grid,
	Radio,
	RadioGroup,
	Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
	DefaultValues,
	FormProvider,
	SubmitHandler,
	useController,
	useForm,
} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { FormType } from '@/api/enum/formType.enum';
import {
	Dispatch,
	forwardRef,
	SetStateAction,
	useEffect,
	useImperativeHandle,
	useState,
} from 'react';
import dayjs from 'dayjs';
import AppDatePicker from '@/common/components/form-inputs/AppDatePicker';
import {
	API_DATE_FORMAT,
	DISPLAY_DATE_FORMAT,
	notFutureDate,
} from '@/utils/dateHelper';
import AppTextField from '@/common/components/form-inputs/AppTextField';
import AppFieldView from '@/common/components/form-view/AppFieldView';
import { formatAge } from '@/utils/ageHelper';
import LocalDataGrid from '@/common/components/dataGrid/LocalDataGrid';
import { GridColDef } from '@mui/x-data-grid';

interface Props {
	type: FormType;
	details?: any;
	allEnumList?: any;
	setType: Dispatch<SetStateAction<FormType>>;
}

const EditDsm5TeenForm = forwardRef(
	({ type, setType, details, allEnumList }: Props, ref) => {
		const { t } = useTranslation();

		const [answerList, setAnswerList] = useState([
			{
				id: 1,
				group: 'I',
				title: t(`preAdmission.troubledProblems2Title1`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 2,
				group: 'I',
				title: t(`preAdmission.troubledProblems2Title2`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 3,
				group: 'II',
				title: t(`preAdmission.troubledProblems2Title3`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 4,
				group: 'III',
				title: t(`preAdmission.troubledProblems2Title4`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 5,
				group: 'IV',
				title: t(`preAdmission.troubledProblems2Title5`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 6,
				group: 'IV',
				title: t(`preAdmission.troubledProblems2Title6`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 7,
				group: 'V 及 VI',
				title: t(`preAdmission.troubledProblems2Title7`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 8,
				group: 'V 及 VI',
				title: t(`preAdmission.troubledProblems2Title8`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 9,
				group: 'VII',
				title: t(`preAdmission.troubledProblems2Title9`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 10,
				group: 'VII',
				title: t(`preAdmission.troubledProblems2Title10`) + '*',
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
				answer5: false,
			},
			{
				id: 11,
				group: 'VIII',
				title: t(`preAdmission.troubledProblems2Title11`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 12,
				group: 'VIII',
				title: t(`preAdmission.troubledProblems2Title12`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 13,
				group: 'VIII',
				title: t(`preAdmission.troubledProblems2Title13`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 14,
				group: 'IX',
				title: t(`preAdmission.troubledProblems2Title14`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 15,
				group: 'X',
				title: t(`preAdmission.troubledProblems2Title15`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 16,
				group: 'XI',
				title: t(`preAdmission.troubledProblems2Title16`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 17,
				group: 'XI',
				title: t(`preAdmission.troubledProblems2Title17`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 18,
				group: 'XI',
				title: t(`preAdmission.troubledProblems2Title18`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
			{
				id: 19,
				group: 'XI',
				title: t(`preAdmission.troubledProblems2Title19`) + '*',
				answer0: false,
				answer1: false,
				answer2: false,
				answer3: false,
				answer4: false,
			},
		]);
		const [answerList2, setAnswerList2] = useState([
			{
				id: 1,
				group: 'XII',
				title: t(`preAdmission.conditionTitle1`) + '*',
				answer0: false,
				answer1: false,
			},
			{
				id: 2,
				group: 'XII',
				title: t(`preAdmission.conditionTitle2`) + '*',
				answer0: false,
				answer1: false,
			},
			{
				id: 3,
				group: 'XII',
				title: t(`preAdmission.conditionTitle3`) + '*',
				answer0: false,
				answer1: false,
			},
			{
				id: 4,
				group: 'XII',
				title: t(`preAdmission.conditionTitle4`) + '*',
				answer0: false,
				answer1: false,
			},
			{
				id: 5,
				group: 'XIII',
				title: t(`preAdmission.conditionTitle5`) + '*',
				answer0: false,
				answer1: false,
			},
			{
				id: 6,
				group: 'XIII',
				title: t(`preAdmission.conditionTitle6`) + '*',
				answer0: false,
				answer1: false,
			},
		]);

		const defaultValues: DefaultValues<any> = {};

		useEffect(() => {
			if (details) {
				methods.reset(details);
				if (details.answerListPartOne) {
					const restoredList = answerList?.map((item: any, index: number) => {
						const row: any = {
							...item,
							answer0: false,
							answer1: false,
							answer2: false,
							answer3: false,
							answer4: false,
						};

						row[`answer${details.answerListPartOne[index]}`] = true;
						return row;
					});
					setAnswerList(restoredList);
					methods.setValue('answerList', restoredList);
				}
				if (details.answerListPartTwo) {
					const restoredList = answerList2?.map((item: any, index: number) => {
						const row: any = {
							...item,
							answer0: false,
							answer1: false,
						};

						row[`answer${details.answerListPartTwo[index]}`] = true;
						return row;
					});
					setAnswerList2(restoredList);
					methods.setValue('answerList2', restoredList);
				}
			}
		}, [details]);

		const formSchema = Yup.object().shape({
			fillingDate: Yup.string()
				.required(t('errorMessage.pleaseSelect'))
				.test(notFutureDate(t('errorMessage.dateCannotBeFuture'))),
			answerList: Yup.array()
				.of(
					Yup.object().test(
						'at-least-one-answer',
						t('errorMessage.pleaseSelect'), // 错误提示
						(row) => {
							if (!row) return false;
							const { answer0, answer1, answer2, answer3, answer4 } =
								row as any;
							return [answer0, answer1, answer2, answer3, answer4].some(
								(val) => val === true
							);
						}
					)
				)
				.required(t('errorMessage.pleaseSelect')),
			answerList2: Yup.array()
				.of(
					Yup.object().test(
						'at-least-one-answer',
						t('errorMessage.pleaseSelect'), // 错误提示
						(row) => {
							if (!row) return false;
							const { answer0, answer1 } = row as any;
							console.log(answer0, answer1);
							return [answer0, answer1].some((val) => val === true);
						}
					)
				)
				.required(t('errorMessage.pleaseSelect')),
		});
		const methods = useForm<any>({
			defaultValues,
			resolver: yupResolver(formSchema),
			mode: 'onChange',
			shouldFocusError: true,
		});

		const answerListField = useController({
			name: 'answerList',
			control: methods.control,
		});
		const answerList2Field = useController({
			name: 'answerList2',
			control: methods.control,
		});

		useImperativeHandle(ref, () => ({
			getFormData: () => methods.getValues(),
			validateForm: () => {
				methods.setValue('answerList', answerList);
				methods.setValue('answerList2', answerList2);

				methods.trigger();
				methods.formState.isValid;
				return methods.trigger().then(() => methods.formState.isValid);
			},
		}));
		const radioRenderCell = (params: any, score: number, type: number) => {
			const { id, row, api } = params;

			const isChecked = row[`answer${score}`] === true;

			const handleChange = () => {
				const updates: Record<string, boolean> = {
					answer0: false,
					answer1: false,
					answer2: false,
					answer3: false,
					answer4: false,
				};
				updates[`answer${score}`] = true;

				console.log(updates);

				api.updateRows([{ id, ...updates }]);
				const list = api.getAllRowIds().map((id: any) => api.getRow(id));
				console.log(list);

				if (type == 1) {
					setAnswerList(list);

					methods.setValue('answerList', list);
				} else {
					setAnswerList2(list);

					methods.setValue('answerList2', list);
				}

				methods.trigger();
			};
			return (
				<Radio checked={isChecked} value={score} onChange={handleChange} />
			);
		};
		const columns: GridColDef[] = [
			{
				field: 'group',
				headerName: '',
				flex: 1,
			},
			{
				field: 'title',
				headerName: t('preAdmission.troubledProblems2Title'),
				flex: 30,
			},
			{
				field: 'answer0',
				headerName: t('preAdmission.scoreOther1'),
				flex: 10,
				renderCell: (params: any) => radioRenderCell(params, 0, 1),
				rowSpanValueGetter: (value, row) => {
					return row ? `${row.title}-${row.answer1}` : value;
				},
			},
			{
				field: 'answer1',
				headerName: t('preAdmission.scoreOther2'),
				flex: 10,
				renderCell: (params: any) => radioRenderCell(params, 1, 1),
				rowSpanValueGetter: (value, row) => {
					return row ? `${row.title}-${row.answer1}` : value;
				},
			},
			{
				field: 'answer2',
				headerName: t('preAdmission.scoreOther3'),
				flex: 10,
				renderCell: (params: any) => radioRenderCell(params, 2, 1),
				rowSpanValueGetter: (value, row) => {
					return row ? `${row.title}-${row.answer1}` : value;
				},
			},
			{
				field: 'answer3',
				headerName: t('preAdmission.scoreOther4'),
				flex: 10,
				renderCell: (params: any) => radioRenderCell(params, 3, 1),
				rowSpanValueGetter: (value, row) => {
					return row ? `${row.title}-${row.answer1}` : value;
				},
			},
			{
				field: 'answer4',
				headerName: t('preAdmission.scoreOther5'),
				flex: 10,
				renderCell: (params: any) => radioRenderCell(params, 4, 1),
				rowSpanValueGetter: (value, row) => {
					return row ? `${row.title}-${row.answer1}` : value;
				},
			},
		];
		const columns2: GridColDef[] = [
			{
				field: 'group',
				headerName: '',
				flex: 1,
			},
			{
				field: 'title',
				headerName: t('preAdmission.conditionTitle'),
				flex: 30,
			},
			{
				field: 'answer1',
				headerName: t('preAdmission.have1'),
				flex: 10,
				renderCell: (params: any) => radioRenderCell(params, 0, 2),
				rowSpanValueGetter: (value, row) => {
					return row ? `${row.title}-${row.answer1}` : value;
				},
			},
			{
				field: 'answer2',
				headerName: t('preAdmission.have2'),
				flex: 10,
				renderCell: (params: any) => radioRenderCell(params, 1, 2),
				rowSpanValueGetter: (value, row) => {
					return row ? `${row.title}-${row.answer1}` : value;
				},
			},
		];
		return (
			<>
				<FormProvider {...methods}>
					<form onSubmit={methods.handleSubmit((e: any) => e.preventDefault())}>
						<Grid container spacing={3} marginTop={0} marginBottom={3}>
							<Grid size={6}>
								<AppFieldView
									label={t('preAdmission.en_name_en')}
									value={details?.nameEn}
								/>
							</Grid>
							<Grid size={6}>
								<AppFieldView
									label={t('preAdmission.zh_name_en')}
									value={details?.nameZh}
								/>
							</Grid>
							<Grid size={6}>
								<AppFieldView
									label={t('preAdmission.zh_age')}
									value={formatAge(
										details?.currentAge,
										details?.currentAgeEstimated,
										'zh'
									)}
								/>
							</Grid>
							<Grid size={6}>
								<AppFieldView
									label={t('preAdmission.zh_sex')}
									value={details?.sexDesc}
								/>
							</Grid>

							<Grid size={6}>
								<AppDatePicker
									control={methods.control}
									name='fillingDate'
									label={t('preAdmission.signatureDate') + '*'}
									maximumDate={dayjs().startOf('day').format(API_DATE_FORMAT)}
								/>
							</Grid>
						</Grid>

						<Divider sx={{ margin: '24px 0' }} />

						<Typography
							variant='h6'
							sx={{ fontWeight: 'bold' }}
							marginBottom={2}
						>
							{t('preAdmission.questionnaireTitle1')}
						</Typography>
						<Typography
							variant='body2'
							sx={{ fontWeight: 'bold' }}
							marginBottom={2}
						>
							{t('preAdmission.Dsm5TeenTips')}
						</Typography>
						<Grid container spacing={3} marginTop={0} marginBottom={3}>
							<Grid size={12} display='flex'>
								<LocalDataGrid
									rows={answerList}
									columns={columns}
									getRowId={(row) => row.id}
									pagination={false}
									rowSpanning={true}
								/>
							</Grid>
						</Grid>
						<FormHelperText color='error' style={{ color: '#d32f2f' }}>
							{answerListField.fieldState.error
								? t('errorMessage.pleaseSelect')
								: ''}
						</FormHelperText>

						<Typography
							variant='h6'
							sx={{ fontWeight: 'bold' }}
							marginBottom={2}
							marginTop={3}
						>
							{t('preAdmission.questionnaireTitle2')}
						</Typography>
						<Typography
							variant='body2'
							sx={{ fontWeight: 'bold' }}
							marginBottom={2}
						>
							{t('preAdmission.Dsm5TeenTips')}
						</Typography>
						<Grid container spacing={3} marginTop={0} marginBottom={3}>
							<Grid size={12} display='flex'>
								<LocalDataGrid
									rows={answerList2}
									columns={columns2}
									getRowId={(row) => row.id}
									pagination={false}
									rowSpanning={true}
								/>
							</Grid>
						</Grid>
						<FormHelperText color='error' style={{ color: '#d32f2f' }}>
							{answerList2Field.fieldState.error
								? t('errorMessage.pleaseSelect')
								: ''}
						</FormHelperText>
					</form>
				</FormProvider>
			</>
		);
	}
);

EditDsm5TeenForm.displayName = 'EditDsm5TeenForm';

export default EditDsm5TeenForm;
